/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	19-11-2021
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_digidag_menu = {};

(function(){

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		Listeners: Bind
		*/
		$(document).on('click','.js-menu-puller',function() {
			specific_digidag_menu.toggleMenu();
		});

		$(document).on('click','.js-menu-button',function() {
			
			specific_digidag_menu.gotoPage(
				$(this).data('page')
			);

		});

		$(document).on('click','.js-page-close',function() {
			specific_digidag_menu.gotoTour();
		});
		
	};
		
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	/*
	Menu: Puller toggle
	*/
	this.togglePuller = function() {

		if(
			$('.js-menu-puller').hasClass('active') == true
		) {

			/*
			Hide: Menu puller
			*/
			$('.js-menu-puller').animate({
				'top':-40
			},400);

			$('.js-menu-puller').removeClass('active');

		} else {

			/*
			Show: Menu puller
			*/
			$('.js-menu-puller').animate({
				'top':-5
			},400);

			$('.js-menu-puller').addClass('active');

		}

	};

	/*
	Menu: Toggle
	*/
	this.toggleMenu = function(
		w
	) {	

		if(
			$('.js-settings-menu').val() == 'true' ||
			w == 0
		) {

			/*
			Audioplayer: Start audio when was playing
			*/
			if($('.js-audioplayer-pausedwhenplaying').val() == 'yes') {

				specific_digidag_audioplayer.togglePlayingPause();

				$('.js-audioplayer-pausedwhenplaying').val('no');
			}

			/*
			Setting: set
			*/
			$('.js-settings-menu').val('false');

			/*
			Hide
			*/
			$('.js-menu-overlay').stop().animate({
				'top':'-100vh'
			},500);	
			$('.js-menu-overlay').find('.background').stop().animate({
				'top':'-100vh'
			},700);	

			/*
			CTA: Show
			*/
			//$('.js-cta').show();

			/*
			Label: Set
			*/
			$('.js-menu-puller').removeClass('black');
			$('.js-menu-puller').find('.label').html('Menu');

		} else {

			/*
			Audioplayer: Pause audio
			*/
			if(
				$('.js-audioplayer-playing').val() == 'true'
			) {
				specific_digidag_audioplayer.togglePlayingPause(0,1);
			} else {
				specific_digidag_audioplayer.togglePlayingPause(0);
			}

			/*
			Setting: set
			*/
			$('.js-settings-menu').val('true');

			/*
			CTA: Hide
			*/
			//$('.js-cta').hide();

			/*
			Show
			*/
			$('.js-menu-overlay').stop().animate({
				'top':0
			},700);	
			$('.js-menu-overlay').find('.background').stop().animate({
				'top':0
			},500);	

			/*
			Label: Set
			*/
			$('.js-menu-puller').addClass('black');
			$('.js-menu-puller').find('.label').html('Menu sluiten');

		}
	};

	/*
	Page: close back to tour
	*/
	this.gotoTour = function(
	) {

		/*
		CTA: Hide
		*/
		// setTimeout(function() {
		// 	if(_isDigidagCTA == 1) {
		// 		$('.js-cta').show();
		// 	}
		// },1000);

		/*
		Scroll to page
		*/
		 $('html, body').stop().animate({
		 	scrollTop: 0
		 }, 400,function() {

			/*
			Empty page
			*/
			$('.js-page').html('');
			$('.js-page').hide();

			/*
			Set: is Page
			*/
			$('.js-settings-ispage').val('false');

		 });

	};

	/*
	Page: load and goto
	*/
	this.gotoPage = function(
		w
	) {

		/*
		CTA: Hide
		*/
		//$('.js-cta').hide();

		/*
		Audioplayer: Pause
		*/
		specific_digidag_audioplayer.togglePlayingPause(0);

		/*
		Scroll div to up
		*/
		$('.js-page').scrollTop(0);

		/*
		Category: Get
		*/
		var _category = $('.js-settings-category').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/l/page-' + _category + '-' + w,
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Set: Url
			*/
			window.history.pushState(
				'',
				'New URL: ' + globalUrl + '/' + _category + '/' + w,
				globalUrl + '/' + _category + '/' + w
			);

			/*
			Set: is Page
			*/
			$('.js-settings-ispage').val('true');

			/*
			Load page
			*/
			$('.js-page').show();
			$('.js-page').html(
				data
			);

			/*
			CTA: Hide
			*/
			$('.js-cta').hide();
			_isDigidagCTA = 0;

			/*
			Scroll to page
			*/
			specific_digidag_menu.scrollToPage(400);

			/*
			Menu: Close
			*/
			specific_digidag_menu.toggleMenu(0);
			
		})
		.always(function() {
		});

	};

	this.scrollToPage = function(time) {

		/*
		Scroll to page
		*/
		$('html, body').stop().animate({
			scrollTop: $('.js-page').offset().top
		}, time);

		/*
		Show scrollbar
		*/
		$('body').css({'overflow':'hidden'});


	};

}).apply(specific_digidag_menu); 